import React from 'react';
import { motion } from 'framer-motion';
interface Tab {
  id: string;
  label: string;
}
interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
}
export function Tabs({
  tabs,
  activeTab,
  onChange
}: TabsProps) {
  return <div className="flex space-x-1 bg-gray-100 dark:bg-slate-800 p-1 rounded-xl" data-id="element-97">
      {tabs.map(tab => <button key={tab.id} onClick={() => onChange(tab.id)} className={`relative flex-1 px-3 py-2 text-sm font-medium rounded-lg transition-colors z-10 ${activeTab === tab.id ? 'text-primary' : 'text-text-muted hover:text-text'}`} data-id="element-98">
          {activeTab === tab.id && <motion.div layoutId="activeTab" className="absolute inset-0 bg-white dark:bg-slate-700 rounded-lg shadow-sm" transition={{
        type: 'spring',
        bounce: 0.2,
        duration: 0.6
      }} style={{
        zIndex: -1
      }} data-id="element-99" />}
          {tab.label}
        </button>)}
    </div>;
}